import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';

import { SelectBoxComponent } from './components/select-box/select-box.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { DateRangeComponent } from './components/date-range/date-range.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    SelectBoxComponent,
    DatePickerComponent,
    DateRangeComponent
  ],
  imports: [
    CommonModule,
    MatSelectModule,
    MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
    MatOptionModule,
    TranslateModule,
  ],
  exports: [
    SelectBoxComponent,
    DatePickerComponent,
    DateRangeComponent
  ]
})
export class SharedFormFieldsModule { }